// Email service voor Strato hosting
// Gebruikt PHP backend scripts in plaats van EmailJS

export const sendContactEmail = async (formData) => {
  try {
    // Try the advanced SMTP script first
    const response = await fetch('/send-email-smtp.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        naam: formData.naam || `${formData.voornaam} ${formData.achternaam}`,
        email: formData.email,
        telefoon: formData.telefoon || '',
        bericht: formData.bericht
      })
    });

    const result = await response.json();
    
    if (result.success) {
      console.log('Email verzonden succesvol via Strato SMTP');
      return { success: true, message: result.message };
    } else {
      console.error('Fout bij verzenden email via SMTP:', result.message);
      
      // Fallback to basic script
      const fallbackResponse = await fetch('/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          naam: formData.naam || `${formData.voornaam} ${formData.achternaam}`,
          email: formData.email,
          telefoon: formData.telefoon || '',
          bericht: formData.bericht
        })
      });
      
      const fallbackResult = await fallbackResponse.json();
      
      if (fallbackResult.success) {
        console.log('Email verzonden succesvol via Strato (fallback)');
        return { success: true, message: fallbackResult.message };
      } else {
        return { success: false, message: fallbackResult.message };
      }
    }
  } catch (error) {
    console.error('Netwerkfout bij verzenden email:', error);
    return { 
      success: false, 
      message: 'Er is een netwerkfout opgetreden. Controleer je internetverbinding en probeer het opnieuw.' 
    };
  }
};

export const sendInterestEmail = async (formData) => {
  try {
    // Create FormData to handle file upload
    const data = new FormData();
    data.append('voornaam', formData.voornaam);
    data.append('achternaam', formData.achternaam);
    data.append('email', formData.email);
    data.append('telefoon', formData.telefoon);
    data.append('bericht', formData.bericht);
    
    // Add CV file if present
    if (formData.cv) {
      data.append('cv', formData.cv);
    }

    const response = await fetch('/send-interest.php', {
      method: 'POST',
      body: data // Don't set Content-Type header, let browser set it with boundary
    });

    const result = await response.json();
    
    if (result.success) {
      console.log('Interesse email met CV verzonden succesvol via Strato');
      return { success: true, message: result.message };
    } else {
      console.error('Fout bij verzenden interesse email:', result.message);
      return { success: false, message: result.message };
    }
  } catch (error) {
    console.error('Netwerkfout bij verzenden interesse email:', error);
    return { 
      success: false, 
      message: 'Er is een netwerkfout opgetreden. Controleer je internetverbinding en probeer het opnieuw.' 
    };
  }
}; 